export const enum DropdownOptions {
    Mute = 'mute',
    Close = 'close',
    Expand = 'expand',
    Minimize = 'minimize',
    ChatList = 'chatList'
}
